import React from 'react';
import { Typography } from '@mui/material';
import { translations } from '../../lib/consts';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import './success.css';

type GenericObject = { [key: string]: any };

type Props = {
    claimId: GenericObject[];
};

const SucessScreen = ({ claimId }: Props) => {
    return (
        <>
            <div className="success-wrapper">
                <Typography variant="caption">{translations.success.SUCCESS}</Typography>
                {/* TODO display claim number and email/sms confirmation notification */}
                <Typography variant="caption">
                    <>
                        {translations.success.CLAIM_NUMBER} {claimId}
                    </>
                </Typography>
                <Typography variant="caption">{translations.success.NOTIFICATION_SEND}</Typography>
            </div>
            <CheckCircleOutlineIcon className="checkIcon" fontSize="large" />
        </>
    );
};

export default SucessScreen;
